/**
 * Copyright (c) 2021, Oracle and/or its affiliates.
 * The Universal Permissive License (UPL), Version 1.0
 */

'use strict';

/**
 * oj-vb-fragment-slot
 * @since  2304.0.0
 *
 * A wrapper of the oj-bind-dom composite component used to inject a fragment template code into a CCA slot
 *
 * <code>
 * &lt;oj-vb-fragment-slot name='[[ slotName ]]' locator='<uniqueId of slot content>' bridge="[[ vbBridge ]]">
 * &lt;/oj-vb-fragment-slot>
 * </code>
 *
 */
define('vb/components/oj-vb-fragment-slot/loader',[
  'ojs/ojcomposite',
  'text!./component.json',
  './fragmentSlotViewModel',
  'ojs/ojbinddom',
], (Composite, metadataJson, viewModel) => {
  const metadata = JSON.parse(metadataJson);
  const view = '<oj-bind-dom config="[[ getSlotConfig() ]]"></oj-bind-dom>';

  Composite.register('oj-vb-fragment-slot', {
    view,
    viewModel,
    metadata,
  });
});

